import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useTranslation } from "../context/Internationalization";
import useFreeAccessAnnouncement from "../Hooks/useFreeAccessAnnouncement";

export default function FreeAccessAnnouncement({
  dismissible = false,
  userId,
}) {
  const { t } = useTranslation();
  const { visible, dismiss } = useFreeAccessAnnouncement({
    dismissible,
    userId,
  });
  if (!visible) return null;

  return (
    <Alert
      severity="info"
      role="status"
      aria-label={t("september_free_access_title")}
      icon={dismissible ? undefined : false}
      onClose={dismissible ? dismiss : undefined}
      closeText={t("close")}
      sx={{
        fontSize: 14,
        "& .MuiAlert-message": { minWidth: 0 },
        ...(dismissible && { mx: { xs: 2, md: 3 }, mt: 3 }),
      }}
    >
      <AlertTitle sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
        {t("september_free_access_title")}
      </AlertTitle>
      {t("september_free_access_description")}
    </Alert>
  );
}
